var _a;
import { ThemeBreakpoints } from '../breakpoints';
var fieldBox = (_a = {},
    _a[ThemeBreakpoints.SMALL] = {
        paddingTop: '2px',
        paddingBottom: '2px',
        paddingLeft: '8px',
        paddingRight: '8px',
        height: '40px',
        activeTranslateX: '0px',
    },
    _a[ThemeBreakpoints.MEDIUM] = {
        paddingTop: '6px',
        paddingBottom: '6px',
        paddingLeft: '8px',
        paddingRight: '8px',
        height: '42px',
        activeTranslateX: '0px',
    },
    _a[ThemeBreakpoints.LARGE] = {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '14px',
        paddingRight: '14px',
        height: '44px',
        activeTranslateX: '5px',
    },
    _a[ThemeBreakpoints.MOBILE] = {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '8px',
        paddingRight: '8px',
        height: '44px',
        activeTranslateX: '5px',
    },
    _a);
export default fieldBox;
